/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FileType } from './FileType';
const MissingFileParser = /* #__PURE__ */ parsers.object([
    ['fileType', FileType, 'file_type'],
    ['name', codecString],
    ['ruleType', /* #__PURE__ */ parsers.exactly('require'), 'rule_type'],
]);
export class MissingFile extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MissingFileParser.decode(input).map(res => new MissingFile(res));
    }
    static unsafeDecode(input) {
        return MissingFile.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MissingFileParser.encode(data);
    }
    static schema() {
        return MissingFileParser.schema();
    }
}
